import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Addresses() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ full_name: "", line1: "", line2: "", city: "", state: "", postal_code: "", country: "US", phone: "", is_default: false });
  const load = () => api.get("/me/addresses").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    await api.post("/me/addresses", form);
    setForm({ full_name: "", line1: "", line2: "", city: "", state: "", postal_code: "", country: "US", phone: "", is_default: false });
    load();
  };
  const del = async (id) => { await api.delete(`/me/addresses/${id}`); load(); };
  return (
    <div className="space-y-8">
      <div>
        <div className="overline mb-3">Saved addresses</div>
        {rows.length === 0 ? (
          <div className="border border-dashed border-black/20 p-8 text-center text-zinc-600">No addresses saved.</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {rows.map((a) => (
              <div key={a.id} className="border border-black/10 p-4">
                <div className="font-display font-semibold">{a.full_name}</div>
                <div className="text-sm text-zinc-600">{a.line1}{a.line2 ? `, ${a.line2}` : ""}</div>
                <div className="text-sm text-zinc-600">{a.city}, {a.state} {a.postal_code}, {a.country}</div>
                <button onClick={() => del(a.id)} className="mt-3 text-sm link-underline">Remove</button>
              </div>
            ))}
          </div>
        )}
      </div>
      <form onSubmit={add} className="border border-black/10 p-6 space-y-4">
        <div className="overline">Add address</div>
        <div className="grid md:grid-cols-2 gap-3">
          <F label="Full name" v={form.full_name} on={(v) => setForm({ ...form, full_name: v })} required />
          <F label="Phone" v={form.phone} on={(v) => setForm({ ...form, phone: v })} />
          <F label="Line 1" v={form.line1} on={(v) => setForm({ ...form, line1: v })} full required />
          <F label="Line 2" v={form.line2} on={(v) => setForm({ ...form, line2: v })} full />
          <F label="City" v={form.city} on={(v) => setForm({ ...form, city: v })} required />
          <F label="State" v={form.state} on={(v) => setForm({ ...form, state: v })} />
          <F label="Postal code" v={form.postal_code} on={(v) => setForm({ ...form, postal_code: v })} required />
          <F label="Country" v={form.country} on={(v) => setForm({ ...form, country: v })} required />
        </div>
        <button className="btn-prm">Save address</button>
      </form>
    </div>
  );
}
function F({ label, v, on, required, full }) {
  return (
    <label className={`block ${full ? "md:col-span-2" : ""}`}>
      <div className="overline mb-1">{label}</div>
      <input value={v} required={required} onChange={(e) => on(e.target.value)} className="w-full border border-black/20 px-3 py-2 outline-none focus:border-black text-sm" />
    </label>
  );
}
